var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCashWithBasket = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1 2v4h1v12h3v4h18V10h-6V6h1V2zm1 3h15V3H2zm1 1h13v4H5v6.999H3zm3 15h15.999V11H6zm8-7c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m0 5c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3m-6.5 1h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0 0 1m13-7h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1m-14-5h6a.5.5 0 0 0 0-1h-6a.5.5 0 0 0 0 1",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCashWithBasket);
export default ForwardRef;